import { styled, Paper, ListItemText, ListItemIcon } from "@mui/material";

export const CustomCardContainer = styled(Paper)(() => ({
  position: "relative",
  padding: "var(--space-2xl)",
  flex: 1,
  borderRadius: "var(--radius-md)",
}));

export const CustomHeaderContainer = styled("div")(() => ({
  marginBottom: "var(--space-lg)",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
}));

export const CustomHeaderTitle = styled("span")(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  fontWeight: "var(--font-weight-bold)",
  fontSize: "var(--font-size-base)",
  gap: "var(--space-xxs)",
}));

export const CustomHighLightTextContainer = styled("div")(() => ({
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "var(--space-xxs)",
  backgroundColor: "var(--color-primary)",
  position: "absolute",
  right: 0,
  top: 0,
  borderTopRightRadius: "var(--radius-xs)",
  borderBottomLeftRadius: "var(--radius-xs)",
  padding: "var(--space-smx)",
  color: "var(--color-text-inverse)",
}));

export const CustomHighLightText = styled("span")(() => ({
  fontSize: "var(--font-size-md)",
}));

export const CustomCardBodyContainer = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "var(--space-xs)",
}));

export const CustomItemTextContent = styled("div")(() => ({
  wordBreak: "break-word",
  whiteSpace: "normal",
  textAlign: "justify",
  fontSize: "var(--font-size-body)",
}));

export const CustomListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: "30px",
  padding: 0,
  display: "flex",
  alignItems: "center",
}));

interface CustomListItemTextProps {
  bold?: boolean;
}

export const CustomListItemText = styled(ListItemText, {
  shouldForwardProp: (prop) => prop !== "bold",
})<CustomListItemTextProps>(({ bold }) => ({
  "& .MuiListItemText-primary": {
    fontSize: "var(--font-size-lg)",
    fontWeight: bold ? "var(--font-weight-bold)" : "var(--font-weight-regular)",
  },
  "& .MuiListItemText-secondary": {
    fontSize: "var(--font-size-body)",
    fontWeight: bold ? "var(--font-weight-bold)" : "var(--font-weight-regular)",
  },
}));
